import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { LocalStorageService } from "angular-2-local-storage";
import { WindowRefService } from "../../utils/window.service";
import { FormService } from "../../utils/form.service";
import { AppService } from "../../utils/app.service";
import { AnalyticsService } from "../../utils/analytics.service";
import { ApiService } from '../../utils/api.service';
import { StateService } from '@uirouter/angular';
@Component({
    selector: 'login-page',
    template: require('./login.html'),
})

export class LoginPageComponent implements OnInit {
    private _window: any;
    private loginForm = {
        form: null,
        $submitting: false,
        $visible: false,
        $errorMsg: '',
        username: '',
        password: '',
        captcha: null,
        state: 'login_ss'
    };
    @Input() params: any;
    constructor(
        private app: AppService,
        private Analytics: AnalyticsService,
        private Form: FormService,
        private localStorageService: LocalStorageService,
        windowRef: WindowRefService,
        private fb: FormBuilder,
        private apiService: ApiService,
        private stateService: StateService
    ) {
        this._window = windowRef.nativeWindow;
        this.loginForm.form = this.fb.group({
            username: [this.loginForm.username, [
                Validators.required,
                Validators.email
            ]],
            password: [this.loginForm.password, [
                Validators.required,
            ]]
        });
        if (this._window.ApiConfig.captcha_key) {
            this.loginForm.form.addControl('captcha', new FormControl(
                this.loginForm.captcha,
                Validators.required
            )
            );
        }
    }

    onInvalid() {
        this.Analytics.trackEvent('SSO Sign In', 'Error', 'Provide required information');
    };

    saveToken(res) {
        this.localStorageService.set('access_token', res.access_token);
        this.apiService.resetHeaders();
        this.stateService.go('ss_select_business');
    };

    connectingToSquareSpace() {
        return JSON.parse(this.localStorageService.get('connecting_ss'));
    }

    login() {
        this.Form.submit(
            this.loginForm,
            this.apiService.getToken.bind(this.apiService),
            this.saveToken.bind(this),
            null,
            this.onInvalid.bind(this),
            null
        );
    };

    ngOnInit() {

        let appParams = <any>this.localStorageService.get('params');
        if (!appParams || !appParams.client_id) {
            this.app.setDefaultParams();
            appParams = <any>this.localStorageService.get('params');
        }

        if (this.params.error) {
            this.loginForm.$visible = true;
            this.loginForm.$errorMsg = this.params.error;
            this.Analytics.trackEvent('SSO Sign In', 'Error', this.params.error);
        } else {
            if (this.params.username) {
                this.loginForm.username = this.params.username;
            }
            this.loginForm.$visible = true;
        }
    };
}
